/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/network.config.json";
import axios from "axios";
import { useEmailId } from "../../../pages/IssuedCredentials/provider";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_CREDENTIAL_LIST } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface INetworkMethods extends IPluginMethodMap {
  getNetworkProps(args: any): Promise<any>;
}

export interface IGetIssuedNetworkProps {
  offset?: number;
  size?: number;
  criteria?:any
}

export class NetworkService implements IAgentPlugin {
  readonly methods: INetworkMethods;

  constructor() {
    this.methods = {
      getNetworkProps: this.getNetworkProps.bind(this),
    };
  }

  async getNetworkProps(args: IGetIssuedNetworkProps) {

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { email } = useEmailId();
    let criteria = {};
    if (email) {
      criteria = {
        email: email,
        ...args?.criteria,
      };
    } else {
      criteria = {
        ...args?.criteria,
      };
    }
    try {
      if (client) {
        const res = await client.query({
          query: GET_CREDENTIAL_LIST,
          variables: {
            input: {
              criteria: criteria,
              offset: args?.offset ?? 0,
              size: args?.size ?? 10,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _nodes = this.formatNodes(res.data?.getListOfCredential?.data);
          let _edges = this.formatEdges(res.data?.getListOfCredential?.data);

          return {
            ...config,
            graphs:{
              edges:_edges,
              nodes: _nodes
            },
            isEmpty: res?.data?.getListOfCredential?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfCredential?.currentPage,
            pageSize: res?.data?.getListOfCredential?.pageSize,
            totalCount: res?.data?.getListOfCredential?.totalCount,
            totalPages: res?.data?.getListOfCredential?.totalPages,
          };
        }
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
    // let headers: any = {};
    // headers.skip = args?.offset ?? 0;
    // headers.limit = args?.size ?? 10;

    // try {
    //   // const res = await axios.post(config.url, {
    //   //   ...headers,
    //   // });
    //   // if (res.data) {
    //   //   let _nodes = this.formatNodes(res.data);
    //   //   return {
    //   //     ...config,
    //   //     graphs: {
    //   //       ...res.data?.graphs,
    //   //       nodes: _nodes,
    //   //     },
    //   //     totalCount: res.data?.totalCount,
    //   //     actualEdgeCount: res.data?.actualEdgecount,
    //   //     activePage: res.data?.currentPage,
    //   //     totalPages: res.data?.totalPages,
    //   //   };
    //   // }
    //   return {
    //     ...(config || {}),
    //   };
    // } catch (err: any) {
    //   console.log("error ");
    // }
  }

  private formatNodes = (data: any) => {
    let unique = data.map(item => item.name).filter((value, index, self) => self.indexOf(value) === index);
  
    let _credentialNodes = unique.map((item:string, index:number)=>{
      let _tempImg = data?.find(key=>key?.name === item);
      console.log(`temp image`, _tempImg);
      return({
        nodeType: "credential",
        id:index,
        title:item,
        image: _tempImg?.image
      })
    });

    let _identityNodes = data?.map((item:any)=>{
      return({
        nodeType:"identity",
        id:item?.id,
        email:item?.email,
        title:item?.to,
        image:`https://ui-avatars.com/api/?name=${item?.to}&background=0D8ABC&color=fff`
      })
    })
    console.log(`unique array`, _credentialNodes);
    // let _nodes = data?.map((item: any) => {
    //   if (item?.nodeType === "credential") {
    //     let _img = item?.details?.find((key: any) => key?.key === "logo");
    //     return {
    //       ...item,
    //       id: item?.id,
    //       title: item?.title,
    //       image: _img?.value ?? item?.image,
    //     };
    //   } else {
    //     return {
    //       ...item,
    //       id: item?.id,
    //       title: item?.title,
    //       image:
    //         item?.image ?? `${config?.defaultImageUrl}?name=${item?.title}`,
    //     };
    //   }
    // });
    return [..._credentialNodes, ..._identityNodes];
  };

  private formatEdges =(data:any)=>{
    let unique = data.map(item => item.name).filter((value, index, self) => self.indexOf(value) === index);
    let _credentialNodes = unique.map((item:string, index:number)=>{
      let _tempImg = data?.find(key=>key?.name === item);
      console.log(`temp image`, _tempImg);
      return({
        nodeType: "credential",
        id:index,
        title:item,
        image: _tempImg?.image
      })
    });

    let _edges = data?.map((item:any)=>{
      let _cred = _credentialNodes?.find(key=>key?.title=== item?.name);
      console.log(`edge cred found`, _cred);
      return({
        from:_cred?.id,
        to:item?.id,
        id:item?.id
      });
    });

    return _edges;
  }
}
